"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var form_1 = require("../../ui/form");

var utils_1 = require("./utils");

var FormUI = function FormUI(dataDef) {
  return function (props) {
    var onSubmit = props.onSubmit,
        onChange = props.onChange,
        onCancel = props.onCancel,
        data = props.data,
        errors = props.errors,
        isAdd = props.isAdd;
    return react_1.default.createElement(form_1.FormLayout, {
      onSubmit: onSubmit,
      onCancel: onCancel
    }, dataDef.fields.filter(function (f) {
      if (typeof f.hideInDetail !== 'undefined' || typeof f.hideInUpdate !== 'undefined') {
        console.warn("Usage of 'hideInDetail' and 'hideInUpdate' are deprecated and won't be supported in the future. Please use 'hide: { detail: true }' or 'hide: { update: true }' instead.");
      }

      return utils_1.shouldShowFieldInForm(f, isAdd);
    }).map(function (f, i) {
      var myOnChange = onChange;

      if (f.onChange) {
        myOnChange = function myOnChange(changedField) {
          if (f.onChange) {
            f.onChange(changedField);
          }

          onChange(changedField);
        };
      }

      return react_1.default.createElement(form_1.Wrapper, {
        key: i,
        label: f.label,
        name: f.name,
        errors: errors,
        type: utils_1.mapTypes(f)
      }, react_1.default.createElement(form_1.InputGeneric, {
        field: f,
        data: data,
        onChange: myOnChange
      }));
    }));
  };
};

exports.default = FormUI;